<!-- This file is not localized on purpose as it's a DE-only integration -->

<form [formGroup]="$any(form).controls.companyData">
  <rt-heading variant="large-x" margin-bottom-small>Unternehmensdaten</rt-heading>

  <div layout-horizontal margin-bottom>
    <rt-form-field margin-right class="company-name-form-field">
      <rt-label>Firmenname</rt-label>
      <rt-input variant="rounded" formControlName="name" />
    </rt-form-field>

    <rt-form-field margin-left class="contact-admin-form-field">
      <rt-label>
        Kontaktperson
        <rt-icon-help [rtTooltip]="'Kontaktperson des Arbeitgebers'" margin-left-small-xx />
      </rt-label>
      <rti-admin-select-input [input]="contactAdminIdFormInput" />
    </rt-form-field>
  </div>

  <rt-heading variant="large" margin-bottom-small>Adresse</rt-heading>

  <rti-gfea-address-input
    [group]="$any(form.controls.companyData).controls.contact.controls.address"
  />
</form>
<rt-divider variant="line" margin-tb />
<form [formGroup]="$any(form).controls.offerData">
  <rt-heading variant="large-x" margin-bottom-small>Stelleninfo</rt-heading>

  <rt-form-field margin-bottom class="title-form-field">
    <rt-label>Stellentitel</rt-label>
    <rt-input variant="rounded" formControlName="title" />
    @if ($any(form.controls.offerData).controls.title.value.length > TITLE_MAX_LENGTH) {
      <div class="length-error">
        {{ 'rti.common.maximum_characters' | translate: { count: TITLE_MAX_LENGTH } }}
      </div>
    }
  </rt-form-field>

  <div layout-horizontal margin-bottom>
    <rt-form-field margin-right class="offer-type-form-field">
      <rt-label>
        Karrierestatus
        <rt-icon-help
          [rtTooltip]="'Klassifizierung der Art des Stellenangebots'"
          margin-left-small-xx
        />
      </rt-label>
      <rt-select
        formControlName="offerType"
        [options]="OFFER_TYPE_OPTIONS"
        [includeEmptyOption]="false"
      />
    </rt-form-field>

    <div layout-vertical margin-left class="profession-form-field">
      <div layout-horizontal margin-bottom-small-x>
        <rt-label>
          Hauptberuf
          <rt-icon-help
            [rtTooltip]="'rti.gfea.form.profession_select_description' | translate"
            margin-left-small-xx
          />
        </rt-label>

        @if (!!titleCodeProfessionCategory && !titleCodeSelection) {
          <span class="badge-required" margin-left-small-xx>*</span>
        }
      </div>

      <rti-gfea-profession-select
        [currentSelection]="titleCodeSelection"
        [professionCategory]="titleCodeProfessionCategory"
        (professionSelected)="titleCodeSelectionChanged($event)"
      />
    </div>
  </div>

  @if (form.get('offerData')?.get('offerType')?.value === OFFER_TYPE_APPRENTICESHIP_ID) {
    <div layout-horizontal margin-bottom>
      <rt-form-field class="education-type-form-field" margin-right>
        <rt-label> Art der Ausbildung </rt-label>
        <rt-select
          formControlName="educationType"
          [options]="EDUCATION_TYPE_OPTIONS"
          [includeEmptyOption]="false"
          [hasSearch]="false"
        />
      </rt-form-field>

      <rt-form-field class="degree-type-form-field" margin-left>
        <rt-label> Art des Dualen Studiums </rt-label>
        <rt-select
          formControlName="degreeType"
          [options]="DEGREE_TYPE_OPTIONS"
          [includeEmptyOption]="false"
          [hasSearch]="false"
        />
      </rt-form-field>
    </div>

    <div layout-horizontal margin-bottom>
      <div layout-vertical class="studies-form-field" padding-right>
        <div layout-horizontal margin-bottom-small-x>
          <rt-label>
            Studienfeld / Studiengang
            <rt-icon-help
              [rtTooltip]="'rti.gfea.form.profession_select_description' | translate"
              margin-left-small-xx
            />
          </rt-label>

          @if (!!courseProfessionCategory && !courseSelection) {
            <span class="badge-required" margin-left-small-xx>*</span>
          }
        </div>

        <rti-gfea-profession-select
          [currentSelection]="courseSelection"
          [professionCategory]="courseProfessionCategory"
          (professionSelected)="courseSelectionChanged($event)"
        />
      </div>
    </div>
  }

  <div layout-horizontal layout-align-items-start margin-bottom>
    <rt-form-field class="working-plan-form-field">
      <rt-label>Arbeitszeit</rt-label>
      <rt-select
        formControlName="workingPlan"
        [options]="workingPlanSelectOptions"
        [includeEmptyOption]="false"
        [disabled]="!form.value.offerData.offerType"
      />
    </rt-form-field>

    <rt-form-field margin-left class="social-insurance-form-field">
      <rt-label>
        Sozialvers.-pflichtig
        <rt-icon-help
          [rtTooltip]="'Angabe ob das Stellenangebot sozialversicherungspflichtig ist oder nicht'"
          margin-left-small-xx
        />
      </rt-label>

      <rt-toggle
        [changeOnlyOnIconClick]="true"
        [disabled]="form.get('offerData')!.get('socialInsurance')!.disabled"
        [checked]="form.value.offerData.socialInsurance"
        (valueChange)="toggleSocialInsuranceAndMiniJob()"
      >
        {{ form.value.offerData.socialInsurance ? 'Ja' : 'Nein' }}
      </rt-toggle>
    </rt-form-field>

    <rt-form-field margin-left class="mini-job-form-field">
      <rt-label>
        Minijob
        <rt-icon-help
          [rtTooltip]="'Angabe, ob es sich beim übertragenen Stellenangebot um einen Minijob handelt'"
          margin-left-small-xx
        />
      </rt-label>

      <rt-toggle
        [changeOnlyOnIconClick]="true"
        [disabled]="form.get('offerData')!.get('miniJob')!.disabled"
        [checked]="form.value.offerData.miniJob"
        (valueChange)="toggleSocialInsuranceAndMiniJob()"
      >
        {{ form.value.offerData.miniJob ? 'Ja' : 'Nein' }}
      </rt-toggle>
    </rt-form-field>
  </div>

  <div layout-horizontal layout-align-items-start margin-bottom>
    <rt-form-field class="number-to-fill-form-field">
      <rt-label>
        Anzahl freier Stellen
        <rt-icon-help
          [rtTooltip]="'Anzahl der offenen Stellen des Stellenangebots'"
          margin-left-small-xx
        />
      </rt-label>
      <rt-input variant="rounded" formControlName="numberToFill" [width]="'60px'" [maxLength]="3" />
    </rt-form-field>

    <rt-form-field margin-left>
      <rt-label>
        Übernahme der Betreuung
        <rt-icon-help
          [rtTooltip]="'Angabe, ob eine Übernahme in die Betreuung durch die Bundesagentur für Arbeit gewünscht wird.'"
          margin-left-small-xx
        />
      </rt-label>

      <rt-toggle
        [changeOnlyOnIconClick]="true"
        [checked]="form.value.offerData.supervisionDesired"
        (valueChange)="toggleSupervisionDesired()"
      >
        {{ form.value.offerData.supervisionDesired ? 'Ja' : 'Nein' }}
      </rt-toggle>
    </rt-form-field>
  </div>

  <div layout-horizontal layout-align-items-start margin-bottom>
    <rt-form-field>
      <rt-label>
        Private Arbeitsvermittlung
        <rt-icon-help
          [rtTooltip]="'Angabe, ob es sich beim übertragenen Stellenangebot um ein Stellenangebot der privaten Arbeitsvermittlung (PAV) handelt. Für Arbeitgeber der Branchen „Vermittlung von Arbeitskräften“ und „Unternehmensberatung“ ist eine Entscheidung zur Markierung des Stellenangebots als Stelle im Rahmen der privaten Arbeitsvermittlung erforderlich.'"
          margin-left-small-xx
        />
      </rt-label>

      <rt-toggle
        [changeOnlyOnIconClick]="true"
        [checked]="form.value.offerData.privatePlacement"
        (valueChange)="togglePrivatePlacement()"
      >
        {{ form.value.offerData.privatePlacement ? 'Ja' : 'Nein' }}
      </rt-toggle>
    </rt-form-field>
    <rt-form-field>
      <rt-label>
        Arbeitnehmerüberlassung
        <rt-icon-help
          [rtTooltip]="'Angabe, ob es sich beim übertragenen Stellenangebot um eine Arbeitnehmerüberlassung handelt.'"
          margin-left-small-xx
        />
      </rt-label>

      <rt-toggle
        [changeOnlyOnIconClick]="true"
        [checked]="form.value.offerData.labourLeasing"
        (valueChange)="toggleLabourLeasing()"
      >
        {{ form.value.offerData.labourLeasing ? 'Ja' : 'Nein' }}
      </rt-toggle>
    </rt-form-field>
  </div>

  <rt-form-field margin-bottom>
    <rt-label>Stellenbeschreibung</rt-label>
    <rt-textarea
      [rows]="10"
      [charactersLimit]="DESCRIPTION_MAX_LENGTH"
      formControlName="description"
    />
    @if ($any(form.controls.offerData).controls.description.value.length < DESCRIPTION_MIN_LENGTH) {
      <div class="length-error">
        {{ 'rti.common.minimum_characters' | translate: { count: DESCRIPTION_MIN_LENGTH } }}
      </div>
    }
  </rt-form-field>

  <rt-form-field margin-bottom class="internet-reference-form-field">
    <rt-label>
      Job-Seite URL
      <rt-icon-help
        [rtTooltip]="'Internetpräsenz des Stellenangebots. Verweist auf die Onlinebewerbungsseite für dieses Stellenangebot.'"
        margin-left-small-xx
      />
    </rt-label>
    <rt-input variant="rounded" formControlName="internetReference" />
  </rt-form-field>

  @if (form.get('offerData')?.get('offerType')?.value) {
    <rt-heading variant="large" margin-bottom-small>Homeoffice</rt-heading>
    <div
      [formGroup]="$any($any(form.controls.offerData).controls.homeoffice)"
      layout-horizontal
      layout-align-items-start
      margin-bottom
    >
      <rt-form-field>
        <rt-label>Homeoffice möglich</rt-label>
        <rt-toggle
          [changeOnlyOnIconClick]="true"
          [checked]="
            $safeNavigationMigration(form.get('offerData.homeoffice.homeofficePossible')?.value)
          "
          (valueChange)="toggleHomeofficePossible()"
        >
          {{ form.get('offerData.homeoffice.homeofficePossible')?.value ? 'Ja' : 'Nein' }}
        </rt-toggle>
      </rt-form-field>

      @if (form.get('offerData.homeoffice.homeofficePossible')?.value === true) {
        <rt-form-field margin-left>
          <rt-label>Maximaler Umfang</rt-label>
          <rt-select
            formControlName="homeofficeType"
            [options]="HOMEOFFICE_TYPE_OPTIONS"
            [includeEmptyOption]="false"
          />
        </rt-form-field>

        @if (
          form.get('offerData.homeoffice.homeofficeType')?.value === HOMEOFFICE_TYPE_PERCENTAGE_ID
        ) {
          <rt-form-field margin-left>
            <rt-label>Anteil in Prozent</rt-label>
            <rt-input
              variant="rounded"
              formControlName="homeofficePercentage"
              [maxLength]="3"
              [width]="'80px'"
            />
          </rt-form-field>
        }
      }
    </div>
  }
  @if (!$any(form.controls.duplicateOfferIds).value) {
    <rt-heading variant="large" margin-bottom-small>Einsatzort</rt-heading>
    <rti-gfea-address-input
      [group]="$any(form.controls.offerData).controls.positionLocation"
      margin-bottom
    />
  }

  @if (form.get('offerData')?.get('offerType')?.value) {
    <rt-heading variant="large" margin-bottom-small>Vergütung</rt-heading>
    <rti-gfea-salary-input
      [group]="$any(form.controls.offerData).controls.salary"
      [offerType]="$safeNavigationMigration(form.get('offerData')?.get('offerType')?.value)"
      [isInEditMode]="isInEditMode"
      margin-bottom
    />
  }

  @if (!selectableOffers) {
    <rt-spinner />
  }
  @if (selectableOffers) {
    <rti-gfea-duplicate-jobs
      [duplicateOfferIdsControl]="$any(form.controls.duplicateOfferIds)"
      [positionLocationsArray]="$any(form.controls.offerData).controls.positionLocations"
      [posting]="posting()"
      [offer]="offer()"
      [selectableOffers]="selectableOffers"
      margin-bottom
    />
  }
</form>
